// USER REQUESTS
export const ADMIN_USERS_REQUEST = 'ADMIN_USERS_REQUEST';
export const ADMIN_USERS_SUCCESS = 'ADMIN_USERS_SUCCESS';
export const ADMIN_USERS_FAIL = 'ADMIN_USERS_FAIL';

// ORDERS REQUEST
export const ADMIN_ORDERS_REQUEST = 'ADMIN_ORDERS_REQUEST';
export const ADMIN_ORDERS_SUCCESS = 'ADMIN_ORDERS_SUCCESS';
export const ADMIN_ORDERS_FAIL = 'ADMIN_ORDERS_FAIL';
// ORDERS UPDATE
export const ADMIN_ORDER_UPDATE_REQUEST = 'ADMIN_ORDER_UPDATE_REQUEST';
export const ADMIN_ORDER_UPDATE_SUCCESS = 'ADMIN_ORDER_UPDATE_SUCCESS';
export const ADMIN_ORDER_UPDATE_FAIL = 'ADMIN_ORDER_UPDATE_FAIL';
// ORDERS DELETE
export const ADMIN_ORDER_DELETE_REQUEST = 'ADMIN_ORDER_DELETE_REQUEST';
export const ADMIN_ORDER_DELETE_SUCCESS = 'ADMIN_ORDER_DELETE_SUCCESS';
export const ADMIN_ORDER_DELETE_FAIL = 'ADMIN_ORDER_DELETE_FAIL';

// PRODUCTS
export const ADMIN_PRODUCTS_REQUEST = 'ADMIN_PRODUCTS_REQUEST';
export const ADMIN_PRODUCTS_SUCCESS = 'ADMIN_PRODUCTS_SUCCESS';
export const ADMIN_PRODUCTS_FAIL = 'ADMIN_PRODUCTS_FAIL';
// PRODUCT DELETE
export const ADMIN_DELETE_PRODUCT_REQUEST = 'ADMIN_DELETE_PRODUCT_REQUEST';
export const ADMIN_DELETE_PRODUCT_SUCCESS = 'ADMIN_DELETE_PRODUCT_SUCCESS';
export const ADMIN_DELETE_PRODUCT_FAIL = 'ADMIN_DELETE_PRODUCT_FAIL';
// PRODUCT ADD
export const ADMIN_ADD_PRODUCT_REQUEST = 'ADMIN_ADD_PRODUCT_REQUEST';
export const ADMIN_ADD_PRODUCT_SUCCESS = 'ADMIN_ADD_PRODUCT_SUCCESS';
export const ADMIN_ADD_PRODUCT_FAIL = 'ADMIN_ADD_PRODUCT_FAIL';
export const ADMIN_ADD_PRODUCT_INITIAL = 'ADMIN_ADD_PRODUCT_INITIAL';
// PRODUCT UPDATE
export const ADMIN_UPDATE_PRODUCT_REQUEST = 'ADMIN_UPDATE_PRODUCT_REQUEST';
export const ADMIN_UPDATE_PRODUCT_SUCCESS = 'ADMIN_UPDATE_PRODUCT_SUCCESS';
export const ADMIN_UPDATE_PRODUCT_FAIL = 'ADMIN_UPDATE_PRODUCT_FAIL';
export const ADMIN_UPDATE_PRODUCT_INITIAL = 'ADMIN_UPDATE_PRODUCT_INITIAL';

// MAKE ADMIN
export const ADMIN_MAKE_REQUEST = 'ADMIN_MAKE_REQUEST';
export const ADMIN_MAKE_SUCCESS = 'ADMIN_MAKE_SUCCESS';
export const ADMIN_MAKE_FAIL = 'ADMIN_MAKE_FAIL';
